import { render, staticRenderFns } from "./SurveyLayout.vue?vue&type=template&id=9248d2d4"
import script from "./SurveyLayout.vue?vue&type=script&lang=js"
export * from "./SurveyLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports